export function requiredElement<T extends Element>(selector: string, root: ParentNode = document): T {
  const element = root.querySelector<T>(selector);
  if (!element) throw new Error(`Required interface element is missing: ${selector}`);
  return element;
}

export function element<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  options: { className?: string; text?: string } = {},
): HTMLElementTagNameMap[K] {
  const result = document.createElement(tag);
  if (options.className) result.className = options.className;
  if (options.text !== undefined) result.textContent = options.text;
  return result;
}

export function closeSiblingMenus(active: HTMLDetailsElement): void {
  for (const details of document.querySelectorAll<HTMLDetailsElement>("details[open]")) {
    if (details !== active) details.open = false;
  }
}

export function wireModalDialog(openButton: HTMLButtonElement, dialog: HTMLDialogElement): void {
  openButton.addEventListener("click", () => dialog.showModal());
  for (const closeButton of dialog.querySelectorAll<HTMLButtonElement>("[data-close-dialog]")) {
    closeButton.addEventListener("click", () => dialog.close());
  }
  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) dialog.close();
  });
}
